import React from 'react';
import './style.css';

function Card({ className = '', children, ...rest }) {
  const classes = ['card', className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Card;

